//@ts-nocheck
import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import App from "./App";

const sfmcDetails = {
  ...window.SFMC_DETAILS,
};
delete window.SFMC_DETAILS;
const invalidJwt = window.INVALID_JWT;
delete window.INVALID_JWT;

ReactDOM.hydrate(
  <App
    sfmcDetails={sfmcDetails}
    invalidJwt={invalidJwt || Object.keys(sfmcDetails).length < 1}
  />,
  document.getElementById("root")
);
